// extracted by mini-css-extract-plugin
export default {"l":"_381d3fda8b"};